import { __decorate, __extends } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import TransportOrder from '../components/addEditCopy/index.vue';

var EditTransportOrderPage = function (_super) {
  __extends(EditTransportOrderPage, _super);

  function EditTransportOrderPage() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  EditTransportOrderPage = __decorate([Component({
    components: {
      TransportOrder: TransportOrder
    }
  })], EditTransportOrderPage);
  return EditTransportOrderPage;
}(Vue);

export default EditTransportOrderPage;